import firebase from "firebase/app";
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDnMVYrFm-CxGOnrhJ9u4kqb_nKJMBGkBU",
  authDomain: "super-festas-bfaf9.firebaseapp.com",
  databaseURL: "https://super-festas-bfaf9.firebaseio.com",
  projectId: "super-festas-bfaf9",
  storageBucket: "super-festas-bfaf9.appspot.com",
  messagingSenderId: "622637651947",
  appId: "1:622637651947:web:240bd87945df44eb"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const database = firebase.database();
export const storage = firebase.storage().ref();